module.exports = __webpack_public_path__ + "prod/1.42.2/img/input-icon-company.83f1d6b2.svg";